import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'display-conditions',
  template: `
    @if (conditions?.length) {
      <pdq-button [plain]="true" (onClick)="displayConditions = !displayConditions">{{
        displayConditions ? 'Hide conditions' : 'Show conditions'
      }}</pdq-button>
      @switch (conditions?.length) {
        @case (0) {
          <div></div>
        }
        @default {
          <div>
            @if (displayConditions) {
              @for (group of conditionsGroup; track group; let i = $index) {
                <div>
                  @if (i > 0) {
                    <div style="margin: 4px 0;">
                      <pdq-tag value="Or" size="small" variant="default" mode="rounded"></pdq-tag>
                    </div>
                  }
                  @for (condition of group; track condition) {
                    <div style="padding: 0 2px; font-size: 12px;">
                      {{ condition | displayCondition: currency }}
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      }
    }
  `,
  standalone: false,
})
export class DisplayConditionsComponent implements OnInit {
  @Input() conditions;
  @Input() currency;
  displayConditions: boolean = false;
  conditionsGroup: any;
  constructor() {}
  ngOnInit() {
    const conditionsGroup = this.conditions.reduce((groups, item: any) => {
      (groups[item.subsetGroupId] = groups[item.subsetGroupId] || []).push(item);
      return groups;
    }, {});
    this.conditionsGroup = Object.values(conditionsGroup);
  }
}
